export const EPUAP = 'EPUAP'
export const CERTYFIKAT_ZUS = 'CERTYFIKAT_ZUS'
